export default {
  name: 'Headline',
  props: {
    headlineType: {
      type: String,
      required: false,
      default: ''
    },
    headlineSize: {
      type: String,
      required: false,
      default: ''
    },
    headlineColor: {
      type: String,
      required: false,
      default: ''
    },
    headlineColorHex: {
      type: String,
      required: false,
      default: ''
    },
    headlineAccentColor: {
      type: String,
      required: false,
      default: ''
    },
    eyebrow: {
      type: Object,
      default: () => ({})
    },
    headline: {
      type: Object,
      default: () => ({})
    },
    lead: {
      type: Object,
      default: () => ({})
    },
    alignHeadline: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    headlineColorCss () {
      return {
        '--headline-color': this.headlineColorHex || this.headlineColor || '#000000'
      }
    },
    headlineAccentColorCss () {
      return this.headlineAccentColor ? { '--headline-accent-color': this.headlineAccentColor } : ''
    }
  },
}
